<eze-modal #modal (onOpen)="onModalOpen()">
	<eze-modal-header>
		<h1>{{ title }}</h1>
	</eze-modal-header>
	<eze-modal-content>
		<eze-alert></eze-alert>

		<div class="instructions">{{ instructions }}</div>

		<div *ngIf="!bypassDocument">
			<form
				class="smart-form"
				novalidate
				[formGroup]="form"
				(ngSubmit)="onSubmit()"
			>
				<div class="row">
					<div class="col-xs-12">
						<eze-event-image-upload
							*ngIf="opened"
							[eventId]="eventId"
							formControlName="document_id"
							[showValidation]="showValidation"
							buttonLabel="Upload Document"
							[uploadType]="'document'"
						></eze-event-image-upload>
					</div>

					<button type="subimit" style="display: none"></button>
				</div>
			</form>
		</div>
	</eze-modal-content>
	<eze-modal-footer>
		<eze-button
			(click)="modal.close()"
			context="default"
			style="margin-right: 10px"
		>
			Cancel
		</eze-button>
		<eze-button (click)="onSubmit()" context="success">Submit</eze-button>
	</eze-modal-footer>
</eze-modal>
